<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
  <div class="centerx">
    <vs-popup
        class="commercial-product-transfer-modal"
        title="Add Alternative Commercial Product"
        :active="visible"
        button-close-hidden
    >
      <vue-form-generator
          ref="form"
          :model="model"
          :schema="schema"
      />
      <div class="vx-col w-full text-right my-3">
        <vs-button class="ml-3" @click="save" color="light" :disabled="localLoading">
          Save
        </vs-button>
        <vs-button class="ml-3" @click="cancel" :disabled="localLoading">
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  props: {
    visible: {
      // using visible instead of value (v-model) because of a conflict with FormModelMixin
      type: Boolean,
      default: false
    },
    apiModel: {
      type: String,
      default: 'commercialProducts'
    },
  },
  components: {},
  mixins: [FormModelMixin, NotificationMixin],
  data () {
    return {
      localLoading: false,
      model: {
        CommercialProduct_FK: {},
      },
      schema: {
        groups: [
          {
            styleClasses: "vx-row w-full",
            fields: [
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "vx-col w-full",
                label: "Commercial Product",
                model: "CommercialProduct_FK",
                values: () => this.commercialProductsOptions,
                selectOptions: {
                  showLabels: false,
                  hideSelected: true,
                  key: "id",
                  trackBy: "id",
                  label: "name",
                },
              },
            ]
          },
        ],
      },
      commercialProductsOptions: [],
      options: [
        {
          endpoint: () => this.$api[this.apiModel].list(),
          optionsFieldName: "commercialProductsOptions",
          nameFieldName: "CommercialProductName",
          idFieldName: 'id',
        },
      ],
    }
  },
  methods: {
    save() {
      if (!this.model.CommercialProduct_FK.id) {
        this.notifyWarning('Please select a Commercial Product');

        return false;
      }
      
      return this.addCommercialProduct(this.model.CommercialProduct_FK.id);
    },
    cancel() {
      this.$emit('cancel');
    },
    async addCommercialProduct(alternativeCommercialProductId) {
      try {
        this.localLoading = true;
        await this.$api[this.apiModel].addAlternativeCommercialProductTo(this.$route.params.id, alternativeCommercialProductId)

        this.$emit('updated');
      } catch (e) {
        this.$emit('error', e.response.data.message || 'Error occurred. Please try again later');
      } finally {
        this.localLoading = false;
      }
    }
  },
}

</script>

<style lang="scss">
  .vs-popup--content {
    overflow: visible;
  }
</style>
